import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/toaster";
import LoginPage from "@/pages/LoginPage";
import SignupPage from "@/pages/SignupPage";
import MemberDashboard from "@/pages/MemberDashboard";
import ManagerDashboard from "@/pages/ManagerDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import OperationsBoard from "@/pages/OperationsBoard";
import UserSelectionPage from "@/pages/UserSelectionPage";
import AuthCallback from "@/pages/AuthCallback";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/identity" element={<UserSelectionPage />} />
      <Route path="/dashboard" element={<MemberDashboard />} />
      <Route path="/manager" element={<ManagerDashboard />} />
      <Route path="/operations" element={<OperationsBoard />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
